<template>
  <div>
    <div class="chart-head-container">
    <h2>
      {{mapHeadline}}
      <button v-tooltip title="Summary of the data collected in each county" class="btn btn-tooltip ms-2"><font-awesome-icon icon="fa-solid fa-info-circle" /></button>
    </h2>
    </div>
    <highcharts :constructorType="'mapChart'" class="hc col-12" :options="chartOptions" ref="chart"></highcharts>
  </div>
</template>

<script setup>
import {
  ref, computed, watch, defineProps,
} from 'vue';
import { useStore } from 'vuex';
import usCounties from '@highcharts/map-collection/countries/us/us-all-all.topo.json';

const props = defineProps({
  selectedMapData: Array,
});
const store = useStore();
const mapType = computed(() => store.getters.getDataType);

const mapHeadline = computed(() => {
  if (mapType.value === 'vehicles') {
    return 'Total Vehicles Per County';
  }
  return 'Miles Traveled By County';
});
const mileClasses = ref([
  {
    from: 0,
    to: 1000,
    color: '#5BCBFC',
  },
  {
    from: 1000,
    to: 3000,
    color: '#0092D6',
  },
  {
    from: 3000,
    to: 6000,
    color: '#0072A7',
  },
  {
    from: 6000,
    color: '#004F74',
  }]);
const vehicleClasses = ref([
  {
    from: 0,
    to: 25,
    color: '#5BCBFC',
  },
  {
    from: 25,
    to: 50,
    color: '#0092D6',
  },
  {
    from: 50,
    to: 75,
    color: '#0072A7',
  },
  {
    from: 75,
    color: '#004F74',
  }]);

const chartOptions = ref({
  chart: {
    map: usCounties,
    height: 600,
    backgroundColor: '#f5f5f5',
  },
  title: {
    text: null,
  },
  legend: {
    valueDecimals: 0,
    align: 'left',
    verticalAlign: 'top',
  },
  navigation: {
    buttonOptions: {
      theme: {
        fill: '#f5f5f5',
      },
    },
  },
  colorAxis: {
    min: 0,
    tickInterval: 5,
    dataClasses: vehicleClasses,
    labels: {
      enabled: false,
    },
  },
  series: [{
    name: 'Vehicles',
    borderWidth: 0.2,
    visible: true,
    nullColor: '#dcdcdc',
    keys: ['id', 'county', 'state', 'value', 'miles'],
    states: {
      hover: {
        color: '#ffa500',
      },
    },
    tooltip: {
      pointFormat: '{point.options.county},{point.options.state}<br /> <b>{point.value} vehicles</b>',

    },
    dataLabels: {
      enabled: false,
      format: '{point.value:,.0f}',
    },
    joinBy: ['fips', 'id'],
    data: props.selectedMapData,
  },
  {
    name: 'Miles',
    visible: false,
    borderWidth: 0.2,
    nullColor: '#dcdcdc',
    keys: ['id', 'county', 'state', 'vehicles', 'value'],
    states: {
      hover: {
        color: '#ffa500',
      },
    },
    tooltip: {
      pointFormat: '{point.options.county},{point.options.state}<br /> <b>{point.value} miles</b>',

    },
    dataLabels: {
      enabled: false,
      format: '{point.value:,.0f}',
    },
    joinBy: ['fips', 'id'],
    data: props.selectedMapData,
  },
  {
    type: 'mapline',
    name: 'State borders',
    color: '#077ae1',
    shadow: false,
    borderWidth: 3,
    accessibility: {
      enabled: false,
    },
  }],
});

function setMapType(type) {
  if (type === 'vehicles') {
    chartOptions.value.colorAxis.dataClasses = vehicleClasses;
    chartOptions.value.series[0].visible = true;
    chartOptions.value.series[1].visible = false;
  } else {
    chartOptions.value.series[0].visible = false;
    chartOptions.value.series[1].visible = true;
    chartOptions.value.colorAxis.dataClasses = mileClasses;
  }
}

watch(() => store.getters.getDataType, (value) => {
  setMapType(value);
});

</script>
